<div id="layout-wrapper">
  <app-sidebar class="sticky-lg-top" [isCondensed]="isCondensed"></app-sidebar>

  <div class="h-100">
    <div class="p-md-4 h-100">
      <div class="main-content card shadow-none p-3 p-md-4 h-100">
        <app-topbar (mobileMenuButtonClicked)="onToggleMobileMenu()"></app-topbar>
        <div class="superadmin-page-content mw-1920px w-100 mx-auto mt-3">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
